import { useCallback, useEffect, useState } from 'react';
import MultiplayerManager from '../MultiplayerManager';
import { ChatMessage, chatMessageReceived } from '../RoomState';

const MAX_MESSAGES = 50;

export function useChat() {
  const [messages, setMessages] = useState<ChatMessage[]>([]);

  useEffect(() => {
    const handler = (msg: ChatMessage) => {
      setMessages((prev) => [...prev.slice(-(MAX_MESSAGES - 1)), msg]);
    };
    chatMessageReceived.subscribe(handler);
    return () => chatMessageReceived.unsubscribe(handler);
  }, []);

  const sendMessage = useCallback((text: string) => {
    if (text.trim()) {
      MultiplayerManager.sendChat(text.trim());
    }
  }, []);

  return { messages, sendMessage };
}
